module.exports = __webpack_public_path__ + "static/media/YF63_3.65443e6e.jpg";